import type { ReactNode } from 'react';

/**
 * Sober DS (v2) — Rise (Story 27.29). Staggered entrance wrapper: each child
 * group rises (opacity + translateY) with an index-based delay. Honors
 * prefers-reduced-motion via the `motion-reduce` variant (no transform/anim).
 */
interface RiseProps {
  index?: number;
  children: ReactNode;
  className?: string;
}

export function Rise({ index = 0, children, className }: RiseProps) {
  return (
    <div
      className={`motion-safe:animate-auth-rise ${className ?? ''}`}
      style={{ animationDelay: `${index * 60}ms` }}
    >
      {children}
    </div>
  );
}
